import React, { Component, useState, useLayoutEffect } from 'react';
import { Show, List, TabbedShowLayout,ReferenceField, Tab, Datagrid, BooleanField, EditButton, TextField, ReferenceManyField, Button, DateField, TopToolbar, RefreshButton, ListButton, ExportButton, useRecordContext, useGetOne, useResourceContext } from 'react-admin';
import CustomModal from '../digitalOrders/CustomModal/CustomModal';
import { CommonHeaderOption, RUN_TIME_API_ENDPOINT } from '../common/common';
import moment from 'moment';
import Swal from 'sweetalert2';
import GetAppIcon from '@mui/icons-material/GetApp';
import { useLocation } from 'react-router-dom';

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };
const apiUrl = RUN_TIME_API_ENDPOINT;

const ShowActions = (props) => {
    const record = useRecordContext();
    const resource = useResourceContext();

    const callExport = (e, data) => {
        console.log('data======>', data);
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        e.preventDefault();
        options.method = 'GET';
        fetch(`${apiUrl}/${resource}_csv/${data.id}`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                console.log('json= inside callback', jsonD.data);
                const msg = jsonD.data ? jsonD.data[0].message : '';
                Swal.fire({
                    html: msg,
                    icon: 'success',
                })
            }).catch(error => {
                return new Promise(function (resolve, reject) {
                    reject({ message: "Something went wrong, please try again." });
                });
            });
    }

    const { data } = useGetOne(
        'surveys',
        { id: record?.id }
      );



        const csvResource = 'empty_data';
        return (
            <React.Fragment >
                <TopToolbar>
                    <RefreshButton />
                    <ListButton basePath={resource} />
                    <div>
                        <button className="export-button"
                            onClick={(e) => callExport(e, data)}
                            // disabled={total === 0}
                            sort={data && data.created_at}
                        >
                            {<GetAppIcon />}
                            <span>Export</span>
                        </button>
                    </div>
                </TopToolbar>
            </React.Fragment >
        )
    }


const ShowTitle = ({ record }) => {
    return record && <span>Survey {record.name}</span>;
};

const TimeComponent = (props) => {
    const record = useRecordContext();
      return (
          <span>
              {moment(record[props.source]).format('HH:mm:ss')}
          </span>
      );
}

const SurveysShow =(props) => {
    const location = useLocation();
    const pathSplit = location.pathname.split('/');
    const promotionId = pathSplit[2]

    const [ loadingShow, setLoadingShow ] = useState(false);
        return (
            <Show actions={<ShowActions props={props} id={promotionId} />} {...props} title={<ShowTitle />}>
                <TabbedShowLayout className="tab-scroll">
                    <Tab label="Details" sort={{ field: 'created_at', order: 'DESC' }} contentClassName="scrollTab">
                        <TextField label="Purpose" source="purpose" />
                        <TextField label="Popup Text" source="popup_text" />
                        <TextField label="Survey Type" source="survey_type" />
                        <TextField label="Targeted Feature" source="targeted_feature" />
                        <DateField label="Start date" source="start_date" />
                        <DateField label="End date" source="end_date" />
                        <TextField label="Start Time" source="start_time" allowEmpty />
                        <TextField label="End Time" source="end_time" allowEmpty />
                        {/* <TimeComponent label="Start Time" source="start_time" default="-" addLabel />
                        <TimeComponent label="End Time" source="end_time" default="-" addLabel /> */}
                        <TextField label="Count of targeted retailers" source="targeted_businesses_count" />
                        <TextField label="Count of retailers given survey" source="survey_result_by_business" />
                        <TextField label="Count of retailers not given survey" source="remainig_businesses_to_give_survey" />
                        <DateField source="created_at" showTime />
                        <DateField source="updated_at" showTime />
                    </Tab>
                    <Tab label="Sold To List">
                        <ReferenceManyField
                            label=""
                            addLabel={false}
                            reference="surveys_sold_to_list"
                            target="id"
                            className="tab-pagination"
                        >
                            <List 
                            actions={false}
                            {...props}
                                filterDefaultValues={{ id: promotionId }}
                                bulkActionButtons={false} exporter={false}>
                                <Datagrid className="tab-data-grid" bulkActionButtons={false}>
                                <ReferenceField
                                    label="User name"
                                    source="user_id"
                                    reference="users"
                                    link="show"
                                    allowEmpty
                                    >
                                    <TextField source="first_name" />
                                </ReferenceField>
                                    <TextField label="Sap Code" source="sap_code" />
                                    <TextField label="Name" source="name" />
                                    <TextField label="Survey Comment" source="survey_comment" />
                                    <TextField label="Survey Answer" source="survey_answer" />
                                    <TextField label="Rating" source="rating" />
                                    <DateField label="Created At" source="created_at" />
                                </Datagrid>
                            </List>
                        </ReferenceManyField>
                    </Tab>
                </TabbedShowLayout>
            </Show>
        );

}

export default SurveysShow;